import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Stats } from '@/modules/common/types';

import StatCard from '../StatCard/StatCard';

interface Props {
  data: Stats[];
  highlightValue?: boolean;
}

const OverviewStats = ({ data, highlightValue = false }: Props) => {
  const { t } = useTranslation();
  return (
    <Grid
      container
      spacing={4}
      sx={{
        alignItems: 'stretch',
      }}
    >
      {data.map((s) => (
        <Grid
          key={s.title}
          size={{
            md: 3,
            sm: 6,
            xs: 12,
          }}
        >
          <StatCard
            title={t(s.title)}
            value={s.value}
            unit={s.unit}
            development={s.development}
            progress={s.progress}
            cardStyles={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
            infoText={s.infoText ? t(s.infoText) : undefined}
            highlightValue={highlightValue}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default OverviewStats;
